import {Injectable} from '@angular/core';
import {PaginatorService} from "@shared/api/services/paginator.service";
import {FormQuestion} from "@shared/api/models/query/form.model";

@Injectable({
    providedIn: 'root'
})
export class FormQuestionsService extends PaginatorService<FormQuestion> {

    protected override get domainEntity() {
        return 'forms';
    };

    protected override get subdomainEntity() {
        return 'questions'
    }
}
